import React from "react";
// components
import PageTitle from "../components/PageTitle/PageTitle";
import Cookies from 'universal-cookie';
import Table from '../widgets/tables/Table';
import Loading from "../components/Loading";
import getFunzionari from "../services/getFunzionari";
import deleteFunzionario from "../services/deleteFunzionario";

export default class Funzionari extends React.Component {

  constructor(props){
    super (props)
  
    this.state = {
        isLoading: true
    };

  }

  async reload() {
    this.setState({ isLoading: true });
    const cookies = new Cookies();
    const username = cookies.get('username', { path: '/' });
    const token = cookies.get('token', { path: '/' });
    
    this.clienti = await getFunzionari(username, token);
    
    this.setState({ isLoading: false });
  }

  async componentDidMount(){
    await this.reload();
  }


  render () {

    if (this.state.isLoading)
        return <Loading />;

    const cookies = new Cookies();

    var headCells = [
      { id: 'nome', numeric: false, disablePadding: true, label: 'Nome' },
      { id: 'cognome', numeric: false, disablePadding: true, label: 'Cognome' },
      { id: '_', numeric: true, disablePadding: false, label: '' },
    ];  

    this.searchCols = ['nome', 'cognome'];

    return (
      <div id={Math.random()}>
        <PageTitle title="Funzionari" button="CREA NUOVO" onClick={() => {
          window.location.href = '/#/app/addFunzionario';
        }}/>

        <Table headCells={headCells} searchCols={this.searchCols} rows={this.clienti}
          onEventClick={(row) => {
          cookies.set('funzionario', row, { path: '/' });
          window.location.href = '/#/app/editFunzionario';
        }}

        onDelete={async (id) => {
          if (window.confirm("Sei sicuro di voler eliminare questo funzionario?") === false) return;

          const cookies = new Cookies();
          const username = cookies.get('username', { path: '/' });
          const token = cookies.get('token', { path: '/' });

          await deleteFunzionario(username, token, id);
          this.reload();
        }}

        />
      </div>
    );
  }
}

